import { BodyCopy } from "../components/BodyCopy";
import { PageTitle } from "lola-framework-ui-test";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../store/globalState";
import { countryDisplayName } from "../utils/country-display";

export interface RouteUnavailableInfoProps {
  /** Destination country ISO alpha-2 (e.g. `MX`). */
  destinationCountry: string;
  /** Pinned payer code from the claim (e.g. `ELEKTRA`), if any. */
  payerCode?: string;
  /** Catalog display name for `payerCode`, when already resolved. */
  payerName?: string;
}

export const RouteUnavailableInfo: React.FC<RouteUnavailableInfoProps> = ({
  destinationCountry,
  payerName,
}) => {
  const { t, i18n } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.errorView;
  const { title, bodyCopy } = colorConfig;

  const countryName = useMemo(
    () => countryDisplayName(destinationCountry, i18n.language || "en"),
    [destinationCountry, i18n.language]
  );

  const payer = payerName?.trim() ?? "";

  return (
    <section className="landing-container">
      <PageTitle
        highlight={t(
          payer ? "routeUnavailable.payerErrorTitle" : "routeUnavailable.errorTitle"
        )}
        highlightColor={title}
        secudnary=""
        secudnaryColor={title}
      />
      <BodyCopy textColor={bodyCopy}>
        {payer
          ? t("routeUnavailable.payerMessage", { payer, country: countryName })
          : t("routeUnavailable.message", { destination: countryName })}
      </BodyCopy>
      <BodyCopy textColor={bodyCopy}>
        {t(payer ? "routeUnavailable.payerHint" : "routeUnavailable.hint")}
      </BodyCopy>
    </section>
  );
};
